enum VehicleTypeClass {
    BUS = 'rioglyph-bus',
    VAN = 'rioglyph-van',
    TRUCK = 'rioglyph-truck',
}

export default VehicleTypeClass;
